/*
  ULTREIA v16 — complementos del pedido ("Antes de terminar").

  En v15 "Agregar" recargaba la página entera para actualizar los totales.
  Acá se agrega con la API del carrito y se vuelven a dibujar SOLO las
  partes que cambian, con la misma API de secciones que usa Dawn:
    · en el cajón: cart-drawer + cart-icon-bubble (y lo pinta el propio
      cajón con renderContents, como cuando se agrega desde una ficha);
    · en /cart: las líneas, el pie con el subtotal, el contador del
      encabezado, los complementos y el cajón (cinco: el máximo que acepta
      la API en un pedido).
  Después el foco va a la línea nueva y se avisa por la región viva, así
  quien navega con teclado o lector de pantalla no queda en el vacío
  (el botón que tocó desapareció: ese producto ya está en el pedido).

  Además, en /cart, cuando cart.js cambia una cantidad o quita una línea,
  se vuelve a pedir la sección de complementos: lo que conviene ofrecer
  depende de lo que quedó adentro.
*/
(function () {
  'use strict';
  if (window.UltreiaCarrito) return;

  function rutas() {
    return window.routes || { cart_add_url: '/cart/add', cart_url: '/cart' };
  }
  function parsear(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }
  function interior(html, selector) {
    var el = parsear(html).querySelector(selector);
    return el ? el.innerHTML : null;
  }
  // constants.js declara PUB_SUB_EVENTS con const: es global, pero no cuelga de window.
  function eventosPubSub() {
    return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  }
  function seccionComplementos() {
    return document.querySelector('[data-u-complementos-seccion]');
  }
  function anunciar(region, texto) {
    if (!region) return;
    region.textContent = '';
    // Un respiro para que el lector de pantalla note el cambio en una región recién dibujada.
    setTimeout(function () { region.textContent = texto; }, 120);
  }
  function enfocarLinea(clave, contenedor) {
    var fila = clave && document.querySelector('[data-u-clave="' + clave.replace(/"/g, '') + '"]');
    var destino = fila && fila.querySelector('.cart-item__name');
    if (!destino) return;
    if (contenedor && typeof window.trapFocus === 'function') window.trapFocus(contenedor, destino);
    else destino.focus();
  }

  /* Variante elegida → precio y botón. Se escucha en captura y se corta
     acá: si el cambio llega a <cart-drawer-items>, Dawn lo toma como un
     cambio de cantidad y falla. */
  document.addEventListener(
    'change',
    function (e) {
      var sel = e.target && e.target.closest && e.target.closest('[data-u-comp-variante]');
      if (!sel) return;
      e.stopPropagation();
      var item = sel.closest('[data-u-comp-item]');
      var op = sel.options[sel.selectedIndex];
      if (!item || !op) return;
      var precio = item.querySelector('[data-u-comp-precio]');
      if (precio && op.dataset.precio) precio.textContent = op.dataset.precio;
      var boton = item.querySelector('[data-u-comp-agregar]');
      if (boton) boton.dataset.variante = op.value;
    },
    true
  );

  document.addEventListener('click', function (e) {
    var boton = e.target && e.target.closest && e.target.closest('[data-u-comp-agregar]');
    if (!boton || boton.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    agregar(boton);
  });

  function agregar(boton) {
    var raiz = boton.closest('[data-u-complementos]');
    var item = boton.closest('[data-u-comp-item]');
    var error = item && item.querySelector('[data-u-comp-error]');
    var enCajon = raiz && raiz.dataset.en === 'cajon';
    var cajon = document.querySelector('cart-drawer');
    var secciones = [];

    if (enCajon) {
      secciones = ['cart-drawer', 'cart-icon-bubble'];
    } else {
      var lineas = document.getElementById('main-cart-items');
      var pie = document.getElementById('main-cart-footer');
      var comp = seccionComplementos();
      if (lineas) secciones.push(lineas.dataset.id);
      if (pie) secciones.push(pie.dataset.id);
      secciones.push('cart-icon-bubble');
      if (comp) secciones.push(comp.dataset.uComplementosSeccion);
      if (cajon) secciones.push('cart-drawer');
    }

    if (error) error.textContent = '';
    boton.classList.add('is-cargando');
    boton.setAttribute('aria-disabled', 'true');
    boton.setAttribute('aria-busy', 'true');

    fetch(rutas().cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(boton.dataset.variante), quantity: 1 }],
        sections: secciones.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        var clave = data.items && data.items[0] && data.items[0].key;
        var nombre = boton.dataset.nombre || '';
        if (enCajon && cajon && typeof cajon.renderContents === 'function') {
          cajon.renderContents(data);
          setTimeout(function () {
            enfocarLinea(clave, document.getElementById('CartDrawer'));
            anunciar(document.getElementById('CartDrawer-LiveRegionText'), 'Agregaste ' + nombre + ' a tu pedido.');
          }, 30);
        } else {
          pintarPagina(data.sections || {}, cajon);
          actualizarCuenta();
          enfocarLinea(clave, null);
          anunciar(document.getElementById('cart-live-region-text'), 'Agregaste ' + nombre + ' a tu pedido.');
        }
        // Avisa al resto del tema (contadores propios, por ejemplo). Va con
        // source 'cart-items' para que cart.js no vuelva a pedir lo que ya
        // se dibujó; el origen propio evita que esta misma hoja se repita.
        var eventos = eventosPubSub();
        if (eventos && typeof window.publish === 'function') {
          window.publish(eventos.cartUpdate, { source: 'cart-items', origen: 'u-complementos', cartData: data });
        }
      })
      .catch(function (err) {
        boton.classList.remove('is-cargando');
        boton.removeAttribute('aria-disabled');
        boton.removeAttribute('aria-busy');
        if (error) error.textContent = (err && err.description) || 'No se pudo agregar. Probá de nuevo.';
      });
  }

  function pintarPagina(sec, cajon) {
    var lineas = document.getElementById('main-cart-items');
    var pie = document.getElementById('main-cart-footer');
    var comp = seccionComplementos();
    if (lineas && sec[lineas.dataset.id]) {
      var nuevo = interior(sec[lineas.dataset.id], '.js-contents');
      var destino = lineas.querySelector('.js-contents');
      if (nuevo !== null && destino) destino.innerHTML = nuevo;
      var items = lineas.closest('cart-items');
      if (items) items.classList.remove('is-empty');
    }
    if (pie && sec[pie.dataset.id]) {
      var nuevoPie = interior(sec[pie.dataset.id], '.js-contents');
      var destinoPie = pie.querySelector('.js-contents');
      if (nuevoPie !== null && destinoPie) destinoPie.innerHTML = nuevoPie;
      pie.classList.remove('is-empty');
    }
    var burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja && sec['cart-icon-bubble']) {
      var b = interior(sec['cart-icon-bubble'], '.shopify-section');
      if (b !== null) burbuja.innerHTML = b;
    }
    if (comp && sec[comp.dataset.uComplementosSeccion]) {
      var c = interior(sec[comp.dataset.uComplementosSeccion], '[data-u-complementos-seccion]');
      if (c !== null) comp.innerHTML = c;
    }
    if (cajon && sec['cart-drawer']) {
      var d = interior(sec['cart-drawer'], '#CartDrawer');
      var destinoCajon = cajon.querySelector('#CartDrawer');
      if (d !== null && destinoCajon) {
        destinoCajon.innerHTML = d;
        cajon.classList.remove('is-empty');
        var capa = cajon.querySelector('#CartDrawer-Overlay');
        if (capa) capa.addEventListener('click', cajon.close.bind(cajon));
      }
    }
  }

  /* /cart: "2 artículos" del título no está en lo que cart.js vuelve a
     dibujar. Se cuenta de las cantidades que quedaron en la tabla. */
  function actualizarCuenta() {
    var rotulo = document.querySelector('[data-u-cuenta-pedido]');
    if (!rotulo) return;
    var total = 0;
    document.querySelectorAll('#main-cart-items .quantity__input').forEach(function (i) {
      total += parseInt(i.value, 10) || 0;
    });
    rotulo.textContent = total === 1 ? '1 artículo' : total + ' artículos';
  }

  /* /cart: después de que cart.js cambia algo, los complementos se
     recalculan en el servidor. */
  function alActualizar(ev) {
    actualizarCuenta();
    if (ev && ev.origen === 'u-complementos') return;
    var comp = seccionComplementos();
    if (!comp) return;
    var id = comp.dataset.uComplementosSeccion;
    fetch(rutas().cart_url + '?section_id=' + encodeURIComponent(id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var c = interior(html, '[data-u-complementos-seccion]');
        if (c !== null) comp.innerHTML = c;
      })
      .catch(function () {});
  }
  function suscribir() {
    var eventos = eventosPubSub();
    if (eventos && typeof window.subscribe === 'function' && (seccionComplementos() || document.querySelector('[data-u-cuenta-pedido]'))) {
      window.subscribe(eventos.cartUpdate, alActualizar);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', suscribir);
  else suscribir();

  window.UltreiaCarrito = { agregar: agregar };
})();
